import classNames from "classnames"
import { AlertColorForm } from "."
import { AlertVariant, TypefaceVariant } from "@/types/alert"
import { convertCamelToKebab } from "@/utils/index"

const ColorPicker = ({
   valueKey,
   options,
   onColorSelect,
}: {
   valueKey: keyof AlertColorForm
   options: AlertVariant[] | TypefaceVariant[]
   onColorSelect: (option: AlertVariant | TypefaceVariant) => void
}) => {
   return (
      <div
         className={classNames(
            "alert-color-setting__color-picker",
            `alert-color-setting__color-picker--${convertCamelToKebab(valueKey)}`
         )}
      >
         {options.map((option) => (
            <div
               key={option}
               className={classNames(
                  "alert-color-setting__color-option",
                  `alert-color-setting__color-option--${option}`
               )}
               onClick={() =>
                  valueKey === "colorCard"
                     ? onColorSelect(
                          Object.keys(AlertVariant).find(
                             (key) =>
                                AlertVariant[
                                   key as keyof typeof AlertVariant
                                ] === option
                          ) as AlertVariant
                       )
                     : onColorSelect(
                          Object.keys(TypefaceVariant).find(
                             (key) =>
                                TypefaceVariant[
                                   key as keyof typeof TypefaceVariant
                                ] === option
                          ) as TypefaceVariant
                       )
               }
            />
         ))}
      </div>
   )
}

export default ColorPicker
